import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-breed-selector-modal',
  templateUrl: './breed-selector-modal.component.html',
  styleUrls: ['./breed-selector-modal.component.scss']
})
export class BreedSelectorModalComponent implements OnInit {
  @Input() breeds: string[] = [];
  page = 1;
  pageSize = 20;

  constructor(public activeModal: NgbActiveModal) { }

  ngOnInit(): void {
  }

}
